import { StyleSheet } from 'aphrodite';
import { SPACE } from '@HoudiniUI/Theme/theme';
import { THEME } from '@Theme';

const mutedText = {
	color: THEME.colors.text.light,
	fontSize: THEME.typography.fontSizes.xs,
	margin: 0,
};

export const styleSheet = StyleSheet.create({
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	helpButton: {
		height: 'auto',
		lineHeight: 1.25,
		minHeight: 27,
	},
	helpCategory: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	helpItem: {
		whiteSpace: 'normal',
	},
	helpMenu: {
		minWidth: 216,
	},
	helpSubmenu: {
		maxHeight: 360,
		overflowY: 'auto',
		width: 320,
	},
	panelBody: {
		boxSizing: 'border-box',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: SPACE[16],
		minHeight: 0,
		overflowY: 'auto',
		padding: SPACE[16],
	},
	panelHeader: {
		alignItems: 'flex-start',
		flexDirection: 'row',
		gap: SPACE[8],
		justifyContent: 'space-between',
	},
	panelHeading: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	promptCard: {
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		padding: SPACE[16],
	},
	promptCardActions: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	promptCardHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
		justifyContent: 'space-between',
	},
	promptCardMeta: mutedText,
	promptCardName: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		margin: 0,
	},
	promptCardSummary: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	savedPrompt: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	savedPromptLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	savedPromptNote: mutedText,
	/** Read-only: this is what the save keeps, verbatim, so it looks like a quoted block rather than a field. */
	savedPromptText: {
		background: THEME.colors.background.main,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
		maxHeight: 160,
		overflowY: 'auto',
		padding: SPACE[8],
		whiteSpace: 'pre-wrap',
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
	},
	sectionCaption: mutedText,
	sectionCount: mutedText,
	/** Between My prompts and the samples: the two lists come from different places, so the break has to read. */
	sectionDivider: {
		border: 'none',
		borderTop: `1px solid ${THEME.colors.border.main}`,
		margin: `${SPACE[8]}px 0`,
		width: '100%',
	},
	sectionEmpty: mutedText,
	sectionHeader: {
		alignItems: 'baseline',
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: SPACE[8],
	},
	sectionTitle: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	trigger: {
		background: THEME.colors.background.light,
		width: '100%',
	},
});
